import useServicePriceTotal from '@/hooks/useServicePriceTotal'
import { Contract, ProductResponse } from '@/modules/Contract/types'
import { useEffect } from 'react'
import { Path, useFormContext, useWatch } from 'react-hook-form'
import { GridHookForm } from 'vnetwork-ui'
import Metadata from '../../../../../../../components/Domain/VNNIC/DomainFormFields/Metadata'
import ServiceTimes from '../../Base/ServiceTimes'

interface TLDsProps {
    index: number
    product: ProductResponse
    isPOC?: boolean
}

const TLDs: React.FC<TLDsProps> = ({ index, isPOC = false }) => {
    const formControl = useFormContext<Contract>()

    const rootName =
        `order.products.[${index}].service_domain_metadata` as Path<Contract>

    const contract_expiry_date = useWatch({
        control: formControl?.control,
        name: `contract_expiry_date`,
    })

    const contract_effective_date = useWatch({
        control: formControl?.control,
        name: `contract_effective_date`,
    })

    useServicePriceTotal({
        setValue: formControl.setValue,
        index,
        control: formControl.control,
        service_configoptions: [],
    })

    useEffect(() => {
        formControl.setValue(
            `order.products.[${index}].service_times.first_startdate` as Path<Contract>,
            contract_effective_date
        )

        formControl.setValue(
            `order.products.[${index}].service_times.first_enddate` as Path<Contract>,
            contract_expiry_date
        )
    }, [JSON.stringify([contract_expiry_date, contract_effective_date])])

    return (
        <div>
            <GridHookForm
                subForm
                actions={[]}
                data={[
                    {
                        renderEditComponent: () => {
                            return (
                                <div data-tour="domain-metadata">
                                    <Metadata
                                        index={index}
                                        rootName={rootName}
                                    />
                                </div>
                            )
                        },
                        className: 'col-span-4',
                    },
                ]}
                formControl={formControl}
            />

            {!isPOC && (
                <ServiceTimes
                    index={index}
                    disabledStatement
                    datesFromContract
                />
            )}
        </div>
    )
}

export default TLDs
